"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrors = void 0;
exports.getErrors = (err) => err.graphQLErrors && err.graphQLErrors.length && err.graphQLErrors[0].state
    ? err.graphQLErrors[0].state
    : {};
//# sourceMappingURL=getErrors.js.map